import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import React, {FC} from 'react'

import {ProcessStageFilterAutocomplete} from './ProcessStageFilterAutocomplete'
import {ProcessStageFilterDropDown} from './ProcessStageFilterDropDown'

type ProcessStageFilterProps = {
  onChange: (processStage?: string[]) => void
  value?: string[]
  removeFilter: (filterName: string) => void
  isCollapsible: boolean
  selectAll?: (filter: string, options: string[]) => void
  plantId: string
}

export const ProcessStageFilter: FC<ProcessStageFilterProps> = ({
  onChange,
  value,
  removeFilter,
  isCollapsible,
  selectAll,
  plantId
}) => {
  const autocompleteProcessStage = useCommonFeatureFlag(FeatureFlagKey.AutocompleteProcessStage, {
    plantId
  })

  return (
    <>
      {autocompleteProcessStage ? (
        <ProcessStageFilterAutocomplete
          plantId={plantId}
          data-test-id="events-filter-bar-processStage"
          onChange={onChange}
          value={value}
        />
      ) : (
        <ProcessStageFilterDropDown
          plantId={plantId}
          data-test-id={'events-filter-bar-processStage'}
          onChange={onChange}
          value={value}
          removeFilter={removeFilter}
          isCollapsible={isCollapsible}
          selectAll={selectAll}
        />
      )}
    </>
  )
}
